//import { Navbar } from "./Homepage/Components/Navbar";

import "./App.css";

import { AllRoute } from "./Routes/Route";

function App() {
  // const [shownav,setShownav]=useState(true);
  // const location = useLocation();

  // useEffect(()=>{
  //   if(location.pathname.includes('admin')||location.pathname.includes('user')||location.pathname.includes('cart')||location.pathname.includes('product')||location.pathname.includes('history')){
  //     setShownav(false);
  //   }else{
  //     setShownav(true);
  //   }
  // },[setShownav,location.pathname])

  return (
    <div className="App">
      {/* //{shownav&&<Topbox />} */}
      <AllRoute />
      {/* kailash use localhost:3000/cart so you can see your cart page ok  <Cart /> */}
    </div>
  );
}

export default App;
